import { format, parseISO, set } from 'date-fns';

export const DEFAULT_DATE_FORMAT = 'MM/dd/yyyy';
export const DATE_TIME_FORMAT = 'MM/dd/yyyy - h:mm a';
export const REVERSED_DEFAULT_DATE_FORMAT = 'yyyy-MM-dd';
export const FULL_DATE_TIME_FORMAT = 'LLL dd, yyyy - h:mm a';
export const FULL_MONTH_DATE_FORMAT = 'MMMM d, yyyy';

type DateFormatType = typeof DATE_TIME_FORMAT | typeof FULL_DATE_TIME_FORMAT;

export const formatPayloadDate = (date: string | Date, dateFormat: string = REVERSED_DEFAULT_DATE_FORMAT) => {
  if (!date) return null;

  return format(new Date(date), dateFormat);
};

export const formatSecondsToMinutes = (seconds: number) => {
  if (seconds == null || Number.isNaN(seconds)) return;

  const total = Math.max(0, Math.floor(seconds));
  const m = Math.floor(total / 60)
    .toString()
    .padStart(2, '0');
  const s = (total % 60).toString().padStart(2, '0');

  return `${m}:${s}`;
};

export const formatDateTimeUTC = (date: string | Date, dateFormat: DateFormatType = DATE_TIME_FORMAT) => {
  if (!date) return '-';

  const value = date instanceof Date ? date : Date.parse(date?.replace('Z', ''));

  return format(value, dateFormat);
};

export const formatDate = (date: string | Date, dateFormat = DEFAULT_DATE_FORMAT) => {
  if (!date) return '-';

  const value = date instanceof Date ? date : parseISO(date);

  return format(value, dateFormat);
};

export const getFormatTimeZoneDate = (selectedDate: Date): Date => {
  const dateNow = new Date();

  return set(selectedDate, {
    hours: dateNow.getHours(),
    minutes: dateNow.getMinutes(),
    seconds: dateNow.getSeconds(),
  });
};
